import type ConversationReadingPaneNode from '../store/schema/ConversationReadingPaneNode';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import getSelectedFolderId from '../utils/getSelectedFolderId';
import type Item from 'owa-service/lib/contract/Item';
import { getStore } from '../store/Store';

/**
 * @returns [item to load based on selected folder, whether item is local, whether item is deleted].
 */
export default function findItemToLoad(
    conversationNode: ConversationReadingPaneNode
): [Item, boolean, boolean] {
    const mailStore = getStore();
    const itemCount =
        conversationNode && conversationNode.itemIds ? conversationNode.itemIds.length : 0;
    if (itemCount === 0) {
        return [null, false, false];
    }

    let foundItem: Item = null;

    const selectedFolderId = getSelectedFolderId();

    // Set isLocal to true if selected folder id is not present
    let isLocal = !selectedFolderId;
    let isDeleted = false;
    if (itemCount === 1) {
        foundItem = mailStore.items.get(conversationNode.itemIds[0]);
        isLocal =
            isLocal ||
            (foundItem.ParentFolderId && foundItem.ParentFolderId.Id === selectedFolderId);
        isDeleted = doesFolderIdEqualName(foundItem.ParentFolderId.Id, 'deleteditems');
        return [foundItem, isLocal, isDeleted];
    }

    let sentItem: Item = null;
    for (const itemId of conversationNode.itemIds) {
        const item = mailStore.items.get(itemId);
        if (item.ParentFolderId && item.ParentFolderId.Id === selectedFolderId) {
            foundItem = item;
            isLocal = true;
            break;
        } else if (doesFolderIdEqualName(item.ParentFolderId.Id, 'sentitems')) {
            sentItem = item;
        }
    }

    if (!foundItem) {
        foundItem = sentItem || mailStore.items.get(conversationNode.itemIds[0]);
    }

    isDeleted = doesFolderIdEqualName(foundItem.ParentFolderId.Id, 'deleteditems');

    return [foundItem, isLocal, isDeleted];
}
